import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  empty: {
    color: grey[500],
    height: "100%",
  },
}));
